import React, { useState } from "react";
import "./profile.css";
import { Header } from "../header/Header";
import { Sidebar } from "../sidebar/Sidebar";

export const Profile = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [search, setSearch] = useState("");
  const [genderFilter, setGenderFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");

  const profiles = [
    {
      id: "P001",
      name: "Rajesh Kumar",
      age: 28,
      profession: "Senior Advocate",
      gender: "Male",
      status: "Verified",
    },
    {
      id: "P002",
      name: "Priya Sharma",
      age: 26,
      profession: "Advocate",
      gender: "Female",
      status: "Pending",
    },
    {
      id: "P003",
      name: "Vikram Singh",
      age: 32,
      profession: "Junior Advocate",
      gender: "Male",
      status: "Verified",
    },
  ];

  const filteredData = profiles.filter((p) => {
    const matchTab =
      activeTab === "all" ||
      (activeTab === "pending" && p.status === "Pending") ||
      (activeTab === "verified" && p.status === "Verified");

    const matchSearch =
      p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.id.toLowerCase().includes(search.toLowerCase());

    const matchGender = genderFilter === "all" || p.gender === genderFilter;
    const matchStatus = statusFilter === "all" || p.status === statusFilter;

    return matchTab && matchSearch && matchGender && matchStatus;
  });

  return (
    <>
      <Header />
      <Sidebar />
      <div className="main-content mt-5">
        {/* Header */}
        <h2 className="mb-3">Profile Management</h2>

        {/* Card */}
        <div className="card shadow-sm rounded-4">
          <div className="card-body">
            {/* Tabs */}
            <div className="row mb-3">
              <div className="col-md-12 d-flex flex-wrap gap-2">
                <button
                  className={`btn btn-outline-primary ${
                    activeTab === "all" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("all")}
                >
                  All Profiles
                </button>
                <button
                  className={`btn btn-outline-primary ${
                    activeTab === "pending" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("pending")}
                >
                  Pending Verification
                </button>
                <button
                  className={`btn btn-outline-primary ${
                    activeTab === "verified" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("verified")}
                >
                  Verified
                </button>
              </div>
            </div>

            {/* Filters */}
            <div className="row mb-3 g-3 align-items-center">
              <div className="col-12 col-md-4">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search profiles..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              <div className="col-12 col-md-4">
                <select
                  className="form-select"
                  value={genderFilter}
                  onChange={(e) => setGenderFilter(e.target.value)}
                >
                  <option value="all">All Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div className="col-12 col-md-4">
                <select
                  className="form-select"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="all">All Status</option>
                  <option value="Verified">Verified</option>
                  <option value="Pending">Pending</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
            </div>

            {/* Table */}
            <div className="table-responsive">
              <table className="table align-middle table-hover">
                <thead className="table-light">
                  <tr>
                    <th>Profile ID</th>
                    <th>Name</th>
                    <th>Age</th>
                    <th>Profession</th>
                    <th>Gender</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.length === 0 ? (
                    <tr>
                      <td colSpan={7} className="text-center">
                        No profiles found
                      </td>
                    </tr>
                  ) : (
                    filteredData.map((p) => (
                      <tr key={p.id}>
                        <td>{p.id}</td>
                        <td>{p.name}</td>
                        <td>{p.age}</td>
                        <td>{p.profession}</td>
                        <td>{p.gender}</td>
                        <td>
                          <span
                            className={`badge rounded-pill px-3 py-1 ${
                              p.status === "Verified"
                                ? "bg-success"
                                : p.status === "Pending"
                                ? "bg-warning text-dark"
                                : "bg-danger"
                            }`}
                          >
                            {p.status}
                          </span>
                        </td>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-secondary me-1"
                            title="View"
                          >
                            <i className="bi bi-eye"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-outline-success me-1"
                            title="Approve"
                          >
                            <i className="bi bi-check-lg"></i>
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            title="Reject"
                          >
                            <i className="bi bi-x-lg"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
